import { createAction, props } from '@ngrx/store';
import { SharedActions } from './actions';
import { PermissionType } from '@app-services/requests/models/permission-type.model';
export const getPermissionTypes = createAction(
  SharedActions.GET_PERMISSION_TYPES
);

export const getPermissionTypesSuccess = createAction(
  SharedActions.GET_PERMISSION_TYPES_SUCCESS,
  props<{ permissions: PermissionType[] }>()
);
